<template>
  <div class="fet-contenteditable single-row-content" 
    contenteditable="true" 
    v-once 
    v-html="value" 
    :value="value" 
    @input="$emit('input', $event.target.innerHTML)" 
    @keydown.enter.prevent
    :placeholder="placeholder ? placeholder : 'Untitled'">
  </div>
</template>

<script>
export default {
  props: ['value', 'placeholder'],
  watch: {
    value: function (newValue) {
      if (document.activeElement == this.$el) 
        return;
        
      this.$el.innerHTML = newValue;
    }
  },
  mounted() {
  
  }
}
</script>

<style scoped>
/* FET Contenteditable */
.fet-contenteditable {display: inline-block;word-break: break-word; }
.fet-contenteditable:empty:before {content: attr(placeholder);-webkit-text-fill-color: #ddd;}
/* In future add function allow multiple row current only allow single row */
.fet-contenteditable.single-row-content {white-space: nowrap;overflow: hidden;}
</style>


